/* tslint:disable */

declare var Object: any;
export interface SFPayProcessInterface {
  "id"?: number;
}

export class SFPayProcess implements SFPayProcessInterface {
  "id": number;
  constructor(data?: SFPayProcessInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFPayProcess`.
   */
  public static getModelName() {
    return "SFPayProcess";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFPayProcess for dynamic purposes.
  **/
  public static factory(data: SFPayProcessInterface): SFPayProcess{
    return new SFPayProcess(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFPayProcess',
      plural: 'SFPayProcesses',
      path: 'SFPayProcesses',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFPayProcess.ts